<app-organizer-shared-layout-list
  [ariaLabel]="'organizer.participant_list.back' | translate"
  [backLink]="backLink | localize"
  [title]="listTitle"
  [subtitle]="
    'organizer.participant_list.subtitle'
      | translate: { total_bookings: totalBookings }
  "
>
  <ng-container>
    <section class="print-timeslot-info">
      <button
        app-vtmn-play-button
        type="button"
        class="mb-5 no-print block"
        (click)="printList()"
      >
        {{ 'organizer.participant.button.print' | translate }}
      </button>
      <app-logo
        class="print-timeslot-info__logo print-logo"
        height="33"
        [name]="logoType.OrganizerDark"
        [alt]="'a11y.fed_landing.logo' | translate"
      ></app-logo>
      <p class="print-timeslot-info__date print">
        {{ timeslot.startDate | localizedDate: 'EEEE d MMMM yyyy' }}
      </p>
      <p class="print-timeslot-info__hours print">
        {{ timeslot.startDate | localizedDate: 'H:mm' }} -
        {{ timeslot.endDate | localizedDate: 'H:mm' }}
      </p>

      <app-activity-card
        class="print-timeslot-info__activity print"
        [printStyle]="true"
        [picture]="getPicture(activity)"
        [title]="activity?.name"
        [address]="activity?.fullAddress"
        [price]="activity?.startingPrice?.amount"
        [isStartingPrice]="true"
        [currency]="activity?.startingPrice?.currency"
        [duration]="activity?.formattedDuration(dateLocale)"
        [visibility]="activity?.visibility"
      ></app-activity-card>
      <p class="print-timeslot-info__attendees print">
        {{ totalAttendees }}
      </p>
    </section>

    <section class="print-timeslot-attendees">
      <ul *ngIf="attendees?.length">
        <li
          *ngFor="let attendee of attendees; let isFirst = first"
          class="flex items-center participant-container print"
          [class.mt-2]="!isFirst"
        >
          <div class="participant-container__info">
            <div class="participant-container__info__name">
              <p>
                {{ attendee.name }}
                <span
                  *ngIf="displayPhoneNumber() && isAdult(attendee.age)"
                  class="text-xs font-medium text-vtmn-play-content-quiet"
                >
                  {{ attendee.contactPhoneNumber }}
                </span>
              </p>
              <p
                *ngIf="attendee.age"
                class="text-xs font-medium text-vtmn-play-content-quiet"
              >
                {{ attendee.age | displayAge }}
              </p>
            </div>
            <div>
              <vtmn-play-icon
                class="radio-button__icon print"
                [name]="iconName"
              ></vtmn-play-icon>
            </div>
          </div>
        </li>
      </ul>
    </section>

    <section
      *ngFor="let bookingItem of bookingItems; let isLast = last"
      class="no-print-timeslot-attendees"
    >
      <div
        *ngIf="
          getOfferByIdentifier(bookingItem.offerIdentifier)?.name ||
          bookingItem.meta?.sports
        "
        class="mb-3"
      >
        <p
          *ngIf="getOfferByIdentifier(bookingItem.offerIdentifier)?.name"
          class="mb-1 text-2xl font-bold text-vtmn-play-content-brand"
        >
          {{
            'organizer.participant_list.booking.formula.title'
              | translate
                : {
                    formula_title: getOfferByIdentifier(
                      bookingItem.offerIdentifier
                    )?.name,
                  }
          }}
        </p>
        <ul *ngIf="bookingItem.meta?.sports" class="pl-4 list-disc text-sm">
          <li *ngFor="let sport of bookingItem.meta.sports">
            {{ sport }}
          </li>
        </ul>
      </div>

      <div class="flex flex-wrap mb-3 text-lg">
        <p class="font-bold">
          {{
            'organizer.participant_list.booking.title'
              | translate: { total_attendee: bookingItem.attendees?.length }
          }}
        </p>
        <p class="ml-auto font-bold text-vtmn-play-content-brand">
          {{ getTotalPrice(bookingItem) | displayPrice: bookingItem.currency }}
        </p>
        <p *ngIf="displayPhoneNumber()" class="w-full text-base">
          {{ getPhoneNumberTranslation(bookingItem?.contactPhoneNumber) }}
        </p>
        <p *ngIf="bookingItem.isImageRightsConsented" class="w-full text-base">
          {{
            'organizer.participant_list.booking.imageRightsConsent' | translate
          }}
        </p>
        <p class="w-full text-base text-vtmn-play-content-quiet">
          {{ formatDate(bookingItem.createdAt) }}
        </p>
      </div>
      <ul *ngIf="bookingItem.attendees?.length">
        <li
          *ngFor="let attendee of bookingItem.attendees; let isFirst = first"
          class="flex items-center"
          [class.mt-2]="!isFirst"
        >
          <vtmn-play-icon
            class="mr-3 p-1 rounded-full bg-vtmn-play-content-brand text-white"
            [name]="iconType.User"
          ></vtmn-play-icon>
          <div>
            <p>{{ attendee.name }}</p>
            <p class="text-sm font-medium text-vtmn-play-content-quiet">
              <span *ngIf="attendee.age">
                {{ attendee.age | displayAge }} •
              </span>
              {{
                getItemPrice(bookingItem) | displayPrice: bookingItem.currency
              }}
              <span
                *ngIf="isFirst && bookingItem.promotion"
                class="no-print-timeslot-attendees__promocode"
              >
                <vtmn-play-icon
                  class="no-print-timeslot-attendees__promocode__icon"
                  [name]="iconType.Gift"
                ></vtmn-play-icon>
                {{ getPromoCodeTrans(bookingItem.promotion?.label) }}
              </span>
            </p>
          </div>
        </li>
      </ul>
      <a
        app-vtmn-play-button
        [variant]="vtmnPlayButtonVariant.SECONDARY"
        class="mt-4 mb-5 py-2 font-condensed"
        [routerLink]="participantManageLink | localize"
        [queryParams]="{ userId: bookingItem.userId }"
        queryParametersHandling="merge"
      >
        {{ 'organizer.participant_list.booking.link.manage' | translate }}
      </a>
      <app-divider
        *ngIf="!isLast"
        class="block -mx-3 xs:-mx-6 sm:-mx-9 md:m-0"
        [variant]="dividerVariant.Small"
      ></app-divider>
    </section>
  </ng-container>
</app-organizer-shared-layout-list>
